"use strict";
// User type definitions — mirrors Django DRF API response shapes.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=user.js.map